import React from 'react';
import { useQuery } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import { useDeps } from 'src/hooks/useDeps';
import { useSelector } from 'react-redux';
import { useIsIrishUser } from 'src/util/cookies';
import { StoreState } from 'src/types/global-types';
import { FooterSkeleton } from 'src/elements/Skeletons/Skeletons';

import footerMenuQuery from '../../queries/jhMenu.graphql';
import { jhMenu, jhMenuVariables } from '../../queries/__generated__/jhMenu';

import { FooterMenu } from './FooterMenus';
import { FooterBlack } from './FooterBlack';
import { FooterWhite } from './FooterWhite';

type FooterProps = Record<string, unknown>;

export const Footer: React.FC<FooterProps> = React.memo(() => {
    const isIrishUser = useIsIrishUser();
    const footerTheme = useSelector((state: StoreState) => state.app.footerTheme);

    const { error, data, loading } = useQuery<jhMenu, jhMenuVariables>(footerMenuQuery, {
        variables: { identifier: isIrishUser ? 'wwe-footer-links-ireland' : 'wwe-footer-links' },
        ssr: useDeps().env.SSR_GQL,
    });

    if (error) {
        Bugsnag.notify(`Could not fetch Footer menus`, (event) => {
            event.addMetadata('errorObject', error);
        });
        return null;
    }
    if (loading) return <FooterSkeleton />;
    if (!data || !Array.isArray(data.jhMenu)) {
        Bugsnag.notify('jhMenu was missing', (event) => {
            event.addMetadata('data', { data: data });
        });
        return null;
    }

    return footerTheme === 'dark' ? (
        <FooterBlack jhMenu={data.jhMenu as FooterMenu[]} />
    ) : (
        <FooterWhite jhMenu={data.jhMenu as FooterMenu[]} />
    );
});
